import React from "react";
import { useSelector } from "react-redux";
import { Navigate, Outlet } from "react-router-dom";

/**
 * Garde de route basée sur une permission précise (ex. 'USER_LIST'), plutôt
 * que sur un rôle fixe. Reflète les mêmes règles que le sidebar
 * (filterMenuByPermissions dans Menu.js) et que le backend (middleware
 * `permit(...)`) : un compte ADMIN ou tout autre rôle disposant de la
 * permission demandée peut accéder, sans être forcément SUPER_ADMIN.
 */
const PermissionRoute = ({ permission }) => {
  const auth = useSelector((state) => state.auth.auth);

  const isAuthenticated = auth?.accessToken;
  const permissions = auth?.user?.permissions || [];

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (permission && !permissions.includes(permission)) {
    return <Navigate to="/page-error-403" replace />;
  }

  return <Outlet />;
};

export default PermissionRoute;
